// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import moment from 'moment/moment'
import { Tooltip } from 'ui_kit_qmd'
import { parseUserDateTime } from '../../../../utils/common'

const PLACEHOLDER = 'System update'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
const getFullName = ({ Prefix, FirstName, LastName, Suffix }) => {
  let author
  author = Prefix ? `${Prefix} ` : ''
  author += FirstName ? `${FirstName} ` : ''
  author += LastName ? `${LastName} ` : ''
  author += Suffix ? `${Suffix} ` : ''

  if (author?.trim()) {
    return author
  }

  return PLACEHOLDER
}

const userTypes = {
  admin: 'Admin',
  provider: 'Provider',
  patient: 'Patient',
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const mapUserType = (type) => userTypes[type]

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const getNameOrPlaceholder = (user) => (user ? getFullName(user) : PLACEHOLDER)

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export default function AuditLogRow({ auditLogs, userTimeZone }) {
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  return auditLogs.map(({ CreateDateTime, User, Message }) => {
    const itemKey = moment(CreateDateTime).valueOf()
    return (
      <>
        <tr className='audit-log-table-body-row' key={itemKey}>
          <td className='audit-log-name' valign='top'>
            <div className='audit-log-name-section'>
              <Tooltip content={getNameOrPlaceholder(User)} targetId={`user-name-${itemKey}`}>
                <div id={`user-name-${itemKey}`} className='audit-log-name-value'>
                  {getNameOrPlaceholder(User)}
                </div>
              </Tooltip>
              {User?.UserType && User?.FirstName ?
                <div className='audit-log-user-type'>{mapUserType(User.UserType)}</div>
              : null}
            </div>
          </td>
          <td className='audit-log-date' valign='top'>
            <div className='audit-log-date-section'>
              <div className='audit-log-date-value'>{parseUserDateTime(CreateDateTime, userTimeZone, true)}</div>
            </div>
          </td>
          <td className='audit-log-message' valign='top'>
            <div className='audit-log-message-section'>
              <div className='audit-log-message-value'>{Message}</div>
            </div>
          </td>
        </tr>
        <div className='separate-line-audit-log' />
      </>
    )
  })
}
